import API_BASE_URL from '../config/api';

/**
 * @param {boolean} activeOnly
 * @returns {Promise<Array>}
 */
export async function listGroceryShops(activeOnly = true) {
  const search = new URLSearchParams();
  search.set('active_only', activeOnly ? 'true' : 'false');
  const res = await fetch(`${API_BASE_URL}/grocery-shops/?${search.toString()}`);
  if (!res.ok) {
    throw new Error(`grocery-shops ${res.status}`);
  }
  const data = await res.json();
  return Array.isArray(data) ? data : [];
}

export async function getGroceryShopById(id) {
  const res = await fetch(`${API_BASE_URL}/grocery-shops/${id}`);
  if (!res.ok) {
    throw new Error(`grocery-shops ${res.status}`);
  }
  return res.json();
}

/**
 * @param {{ grocery_shop_id?: number, category?: string, is_african?: boolean, search?: string, skip?: number, limit?: number, active_only?: boolean }} params
 * @returns {Promise<Array>}
 */
/**
 * Plats tagués épicerie (is_grocery_product) visibles sur le marketplace.
 * @param {{ restaurant_id?: number, skip?: number, limit?: number }} params
 * @returns {Promise<Array>}
 */
export async function getPublicGroceryDishes(params = {}) {
  const search = new URLSearchParams();
  if (params.restaurant_id != null) search.set('restaurant_id', String(params.restaurant_id));
  search.set('skip', String(params.skip ?? 0));
  search.set('limit', String(params.limit ?? 40));
  const res = await fetch(`${API_BASE_URL}/dishes/grocery/public?${search.toString()}`);
  if (!res.ok) {
    throw new Error(`dishes/grocery/public ${res.status}`);
  }
  const data = await res.json();
  return Array.isArray(data) ? data : [];
}

export async function getGroceryShopProducts(params = {}) {
  const search = new URLSearchParams();
  if (params.grocery_shop_id != null) search.set('grocery_shop_id', String(params.grocery_shop_id));
  if (params.category) search.set('category', params.category);
  if (params.is_african != null) search.set('is_african', String(params.is_african));
  if (params.search) search.set('search', params.search);
  search.set('skip', String(params.skip ?? 0));
  search.set('limit', String(params.limit ?? 40));
  search.set('active_only', params.active_only === false ? 'false' : 'true');

  const res = await fetch(`${API_BASE_URL}/grocery-shop-products/?${search.toString()}`);
  if (!res.ok) {
    throw new Error(`grocery-shop-products ${res.status}`);
  }
  const data = await res.json();
  return Array.isArray(data) ? data : [];
}

/**
 * @param {number|string} id
 * @returns {Promise<Record<string, unknown>>}
 */
export async function getGroceryShopProductById(id) {
  const res = await fetch(`${API_BASE_URL}/grocery-shop-products/${id}`);
  if (!res.ok) {
    throw new Error(`grocery-shop-products ${res.status}`);
  }
  return res.json();
}
